<template>
  <div style="height: 750px;">
    <div v-if="showView">
      <div class="intros">
        <h3 class="formtitle">Banner</h3>
        <div class="desc">
          {{$t('global.请选择图片上传：大小1160 * 330像素支持JPG、PNG等格式，图片需小于2M')}}
          <span
            class="maxsize"
          >{{$t('global.最多')}} 5 {{$t('global.个')}}</span>
        </div>
      </div>
      <div class="uploadtable">
        <table>
          <tbody>
            <tr>
              <td width="80">{{$t('global.顺序')}}</td>
              <td width="140">{{$t('global.图片')}}</td>
              <td class="pl20 linkwd">{{$t('global.链接')}}</td>
              <td width="60" class="tdstate">{{$t('global.状态')}}</td>
              <td class="datatime">{{$t('global.创建日期')}}</td>
              <td>{{$t('global.设置')}}</td>
            </tr>
          </tbody>
          <tr class="rowstyle" v-for="(item ,index) of  topicBanner" :key="item.id">
            <td>{{index+1}}</td>
            <td class="showimg">
              <img height="50" width="30" :src="item.bannerImage | imageUrl('',140,58)" />
            </td>
            <td class="pl20 linkwd">
              <a>{{item.url}}</a>
            </td>
            <td class="tdstate" v-if="item.status == 1">{{$t('global.在线')}}</td>
            <td class="tdstate" v-if="item.status == 0">{{$t('global.下线')}}</td>
            <td class="datatime">{{timeStamp(item.createTime)}}</td>
            <td>
              <a
                class="tdsetting"
                @click="changStatus(item)"
                download
              >{{item.status == 0 ? $t('global.上线') : $t('global.下线') }}</a>
              <a class="tdsetting" @click="eidtBanner(item)">{{$t('global.编辑')}}</a>
              <a class="tdsetting" @click="deleteBtns">{{$t('global.删除')}}</a>
            </td>
          </tr>
        </table>
        <a
          class="addBanner"
          v-if="topicBanner.length<5"
          @click="addbanner"
        >{{$t('global.添加')}}banner</a>
      </div>
    </div>

    <div v-else>
      <div class="intros">
        <h3 class="formtitle">Banner/{{$t('global.编辑')}}</h3>
        <div class="desc">{{$t('global.请选择图片上传：大小1160 * 300像素支持JPG、PNG等格式，图片需小于2M')}}</div>
      </div>
      <div class="upcontentinfor">
        <div class="upcontent">
          <div class="upcontent1">
            <span
              class="change"
              @click="reUpload"
              v-show="item.bannerImage != ''"
            >{{$t('global.重新选择')}}</span>
            <cropImg
              ref="cropComponent"
              :dialogWidth="dialogWidth"
              :dialogHeight="dialogHeight"
              :cropWidth="cropWidth"
              :cropHeight="cropHeight"
              :minWidth="minWidth"
              :minHeight="minHeight"
              :fixed="fixed"
              :fixedBox="fixedBox"
              :fixedNumber="fixedNumber"
              :original="original"
              @update-img="updateImage"
              :is-upload="item.bannerImage == '' || isUpload"
            ></cropImg>

            <div
              style="width: 580px;height: 180px;"
              class="endcroping"
              v-show="item.bannerImage != ''"
            >
              <img :src="item.bannerImage | imageUrl('',1160,300)" />
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="linkaddress">
          <span class="formtitle">{{$t('global.链接地址')}}</span>
          <input type="text" v-model="item.url" />
        </div>
        <div class="line"></div>
        <div class="onstateing">
          <span class="formtitle">{{$t('global.状态')}}</span>
          <select v-model="item.status">
            <option value="1">{{$t('global.在线')}}</option>
            <option value="0">{{$t('global.下线')}}</option>
          </select>
        </div>
        <a class="surebtn" @click="saveOredit">{{$t('global.确定')}}</a>
      </div>

      <input
        style="display: none"
        type="file"
        class="upInputIMG1"
        accept="image/*"
      />
    </div>

    <div v-if="fixlayout" class="fixlayout"></div>
    <div v-if="fixlayout" class="delbanner" v-for="(item ,index) of  topicBanner" :key="item.id">
      <p>{{$t('global.提示')}}</p>
      <div class="delinfor">{{$t('global.确定删除此banner吗')}}</div>
      <div class="delbannerbtn">
        <a @click="closepopus">{{$t('global.取消')}}</a>
        <a @click="deleteImg(item.id,index)">{{$t('global.确定')}}</a>
      </div>
      <img src="/static/uploadvideo/closepopus.png" class="closepopus" @click="closepopus" />
    </div>
  </div>
</template>

<script>
import cropImg from "@/components/CropImg.vue";
import * as qiniu from "qiniu-js";
export default {
  name: "itemStep2",
  components: {
    cropImg
  },
  data() {
    return {
      topicId: "",
      topicBanner: [],
      showView: true,
      images: [],
      item: {
        id: "",
        bannerImage: "",
        url: "",
        status: 1,
        topicId: "",
        bannerUrl: ""
      },
      isUpload: false,
      fixlayout: false,
      dialogWidth: 1260,
      dialogHeight: 500,
      cropWidth: 1160,
      cropHeight: 300,
      minWidth: 1160,
      minHeight: 300,
      fixed: true,
      fixedNumber: [58, 15],
      fixedBox: true,
      original: false
    };
  },
  created() {
    //获取topicid
    this.topicId = this.$route.params.id;
    this.getTopicBanner();
  },
  methods: {
    addbanner() {
      if (this.topicBanner.length >= 5) return;

      this.showView = false;
      this.item = {
        id: "",
        bannerImage: "",
        url: "",
        status: 1,
        topicId: ""
      };
    },
    reUpload() {
      this.$refs.cropComponent.reUpload("3size");
    },
    changStatus(item) {
      let s = 0;
      if (item.status == 0) {
        s = 1;
      } else {
        s = 0;
      }
      debugger;
      this.$http
        .post("/api/topic/banner/changStatus", {
          topicBannerIds: item.id,
          status: s
        })
        .then(response => {
          if (response.code == "OK") {
            item.status = s;
          }
        });
    },
    eidtBanner(item) {
      this.item = item;
      this.item["bannerUrl"] = item.bannerImage;
      this.showView = false;
    },
    windowOpen(value) {
      let filePath = encodeURI(value);
      window.location.href = `/api/common/download/file?filePath=${filePath}&type=0`;
    },
    getTopicBanner() {
      if (this.topicId != "" && this.topicId != undefined) {
        var $this = this;
        this.$http
          .get("/api/topic/banner/list", {
            params: {
              topicId: this.topicId
            }
          })
          .then(response => {
            $this.topicBanner = response.data;
          });
      }
    },
    updateImage(img) {
      let $this = this;
      this.bannerImage = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.bannerImage, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.item.bannerUrl = res.key;
        $this.item.bannerImage = res.key;
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "banner");
      // // param.append("deleteNames", this.item.bannerUrl);

      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(response => {
      //     this.$message({
      //       message: response.message,
      //       type: "success"
      //     });

      //     this.item.bannerUrl = response.data.banner.key;
      //     this.item.bannerImage = response.data.banner.key;
      //   });
    },
    deleteBtns() {
      this.fixlayout = true;
      document.documentElement.style.overflowY = "hidden";
    },
    deleteImg(imageId, index) {
      this.fixlayout = false;
      document.documentElement.style.overflowY = "scroll";
      this.topicBanner.splice(index, 1);
      var $this = this;
      this.$http
        .get("/api/topic/banner/delete", {
          params: {
            topicBannerId: imageId
          }
        })
        .then(response => {
          $this.$message({
            message: this.$t("global.删除成功"),
            type: "success",
            duration: 1000
          });
        });
    },
    closepopus() {
      this.fixlayout = false;
      document.documentElement.style.overflowY = "scroll";
    },

    upImgClick(index) {
      this.$store.dispatch("setImgIndex", index);
      if (index === 1) {
        document.querySelector(".upInputIMG").click();
      } else {
        document.querySelector(".upInputIMG1").click();
      }
    },
    saveOredit() {
      let item = this.item;
      let url = "";
      item.topicId = this.topicId;
      if (this.item.id == "") {
        url = "/api/topic/banner/create";
      } else if (this.item.id != null && this.item.id != "") {
        url = "/api/topic/banner/update";
      }

      this.$http.post(url, item).then(response => {
        if (response.code == "OK") {
          this.$message({
            message: this.$t("global.操作成功"),
            type: "success",
            duration: 1000
          });
          this.showView = true;
          this.getTopicBanner();
        } else {
          this.$message(this.$t("global.操作失败"));
        }
      });
    }
  }
};
</script>

<style scoped>
.el-form {
  float: left;
  width: 994px;
  padding: 22px 13px 0 50px;
  background-color: #fff;
  box-sizing: border-box;
}
.intros {
  padding: 22px 50px 30px;
  overflow: hidden;
  background-color: #fff;
  border-top: 1px solid rgba(238, 238, 238, 1);
  box-sizing: border-box;
}
.formtitle {
  float: left;
  width: 100px;
  font-size: 14px;
  font-weight: bold;
  color: #000;
}
.desc {
  float: left;
  height: 19px;
  font-size: 12px;
  color: #999;
  line-height: 22px;
}

.uploadtable {
  padding: 0 60px 40px 60px;
  background-color: #fff;
}
.uploadtable table {
  width: 874px;
  border-collapse: collapse;
}
.uploadtable tbody {
  border-bottom: 1px solid #edecf1;
}
.uploadtable tbody td {
  color: #000;
  padding: 12px 0;
  font-size: 14px;
  font-weight: bold;
}
.rowstyle {
  border-bottom: 1px solid #edecf1;
}
.rowstyle:last-child {
  border-bottom: none;
}
.uploadtable .rowstyle td {
  padding: 13px 0;
}

.uploadtable .pl20 {
  padding: 13px 0 13px 20px !important;
}
.addBanner {
  display: block;
  width: 103px;
  height: 32px;
  color: #fff;
  cursor: pointer;
  margin: 40px auto 0;
  border-radius: 2px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  background: rgba(0, 173, 239, 1);
}
.itemStep2,
.additem {
  display: none;
}
.upcontentinfor {
  padding: 0 50px;
}
.upcontent {
  width: 580px;
  height: 180px;
  margin-left: 100px;
  background: rgba(241, 242, 246, 1);
  border-radius: 2px;
  border: 1px solid rgba(239, 239, 243, 1);
}
.upcontentinfor .line {
  height: 1px;
  margin: 30px 0;
  background-color: #edecf1;
}
.linkaddress,
.onstateing {
  overflow: hidden;
  line-height: 37px;
  margin-bottom: 50px;
}
.linkaddress input {
  float: left;
  width: 489px;
  height: 37px;
  border-radius: 5px;
  padding-left: 10px;
  border: 1px solid rgba(229, 233, 237, 1);
  background-color: rgba(245, 245, 245, 1);
  box-sizing: border-box;
}
.onstateing .formtitle {
  padding-left: 26px;
  box-sizing: border-box;
}
.onstateing select {
  width: 168px;
  height: 37px;
  outline: none;
  color: #333;
  font-size: 14px;
  padding-left: 10px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  border: 1px solid rgba(229, 233, 237, 1);
  box-sizing: border-box;
}
.linkwd {
  width: 220px;
}
.linkwd a {
  display: block;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showimg img {
  width: 140px;
  height: 58px;
}
.uploadtable tbody .tdstate {
  padding: 12px 0 12px 20px;
}
.uploadtable .rowstyle .tdstate {
  padding: 13px 0 13px 20px;
}
.uploadtable tbody .datatime {
  padding: 12px 0 12px 10px;
}
.uploadtable .rowstyle .datatime {
  padding: 13px 0 13px 10px;
}
.tdsetting {
  color: #4a90e2;
  font-size: 14px;
  margin-right: 5px;
  cursor: pointer;
}
.maxsize {
  color: #ff0000;
  margin-left: 5px;
}
.upcontent1 {
  position: relative;
  overflow: hidden;
}
.upcontent1 .upload {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  z-index: 10;
  background-size: cover;
  background-repeat: no-repeat;
}
.upcontent1 .uploadwidth {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.surebtn {
  display: inline-block;
  width: 70px;
  height: 30px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-heiht: 14px;
  line-height: 30px;
  border-radius: 5px;
  margin-left: 100px;
  cursor: pointer;
  background-color: #409eff;
}
.add-wrap .add {
  padding: 52px 0 0 275px;
}
.add-wrap .font {
  text-align: center;
}
.renewload {
  position: absolute;
  display: inline-block;
  width: 55px;
  height: 22px;
  bottom: -145px;
  right: 7px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  z-index: 11;
  cursor: pointer;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.6);
}
.endcroping img {
  width: 100%;
  height: 100%;
  border-radius: 0 !important;
}
.upcontent1 .change {
  position: absolute;
  display: inline-block;
  width: 55px;
  height: 22px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 22px;
  right: 10px;
  bottom: 10px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.7);
}
.fixlayout {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.delbanner {
  position: fixed;
  width: 300px;
  height: 227px;
  z-index: 10000;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  background-color: #fff;
  transform: translate(-50%, -50%);
}
.delbanner p {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
  color: #333;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #e5e9ef;
  box-sizing: border-box;
}
.delbanner .delinfor {
  font-size: 16px;
  color: #000;
  text-align: center;
  margin: 49px 0;
}
.delbanner .delbannerbtn {
  text-align: center;
}
.delbanner .delbannerbtn a {
  display: inline-block;
  width: 100px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  background-color: #03a1d6;
}
.delbanner .delbannerbtn a:first-child {
  color: #000;
  margin: 0 8px 0 0;
  background: rgba(202, 202, 202, 1);
}
.delbanner .closepopus {
  position: absolute;
  top: 15px;
  right: 9px;
  width: 17px;
  height: 17px;
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/pages/v2/subject/step/Step2.vue